import Model from './BaseModel';
import Market from './Market.js';

export default class EventMarketGroup extends Model {
	resourceName() {
		return 'event_market_groups';
	}

	fields() {
		return ['default_open', 'is_key', 'is_primary', 'name', 'order'];
	}

	relationships() {
		return {
			markets: new Market()
		};
	}
}
